import type { SiteDetail, SiteListResponse } from "@repo/gail-document";
import { apiFetchWithStatus, type ApiResponseWithStatus } from "@/lib/api";
import { GAIL_API } from "@/utils/common/constants/routes";

/**
 * Galactus Sites endpoints (Galactus PR #1732), on the customer route group like the rest of
 * the app: the org comes from the caller's token, so there is no org id in the path. Any org
 * member can read; another org's id is a 404.
 */
const SITES_URL = `${GAIL_API}/.internal/customer/sites`;

function siteUrl(id: string): string {
  return `${SITES_URL}/${encodeURIComponent(id)}`;
}

export async function listSites(): Promise<ApiResponseWithStatus<SiteListResponse>> {
  return apiFetchWithStatus<SiteListResponse>(SITES_URL, "GET");
}

export async function getSite(id: string): Promise<ApiResponseWithStatus<SiteDetail>> {
  return apiFetchWithStatus<SiteDetail>(siteUrl(id), "GET");
}
